import { marked } from 'marked';
import React from 'react';
import DOMPurify from 'dompurify';

function UserMessage({ message }) {
  return (
    <div className="msg-row user">
      <div className="bubble" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(message)) }} />
    </div>
  );
}

export default UserMessage;
